import React, { useEffect, useState, useContext } from 'react'
import { MediaUrl } from '../../utils/media/Media';
import { isBrowser, isMobile } from 'react-device-detect';
import dayjs from 'dayjs';
import { UserContext } from '../../../AppContextProvider';
import { QRCodeSVG } from 'qrcode.react';
import { useFetch } from '../../api/FetchApiData';
import { TicketView } from '../sales/Sale';
import eye_open_icon from '../../icons/open_eye.webp';
import eye_close_icon from '../../icons/closed_eye.webp';
if (isMobile)
    import('./payment_mob.css').then(() => {});
else
    import('./payment.css').then(() => {});

function Payment({_payment, User, setNotification}) 
{
    const [payment,setPayment] = useState(_payment);
    const [dispHistory,setDispHistory] = useState({display:'none',btnText:'+'});
    const [statusColor,setStatusColor] = useState('green');
    const [UserState, setUserState] = useContext(UserContext);
    const [details,setDetails] = useState({details:false,img_src:eye_open_icon});
    const fetchData = useFetch();

    useEffect(()=>{
        if(payment.status==='non terminé')
            setStatusColor('orangered');
        else
            setStatusColor('green');
    },[payment.status])

    const UpdateStatus = ()=>{
        if(payment.status === _payment.status)
            return
        fetchData.PutData({'status':payment.status, id:payment.id},'user/payment/1/').then((result)=>{
            if(result.result)
            {
                setNotification({text:`Le status du  paiement ${payment.id} a été correctement mis à jour`,color:'green',display:'block'});
                setPayment({...result.payment});
                setTimeout(()=>{setNotification({text:"", color:'black', display:'none'})},10000);
            }
            else
            {
                setNotification({text:`Le status du  paiement ${payment.id} a été correctement mis à jour`,color:'orangered',display:'block'});
                setTimeout(()=>{setNotification({text:"", color:'black', display:'none'})},10000);
            }
        })
    }

    useEffect(()=>{
        setDetails({...details,img_src: details.details ? eye_close_icon : eye_open_icon});
    },[details.details]);
    
    let qr_width = 50;
    if((payment.mode === 'Cash') && (User.is_staff || User.is_partner) && isBrowser)
        qr_width = 20
    return(
    <div className='payment'>
        <div style={{}}>
                <img src={details.img_src} className='sale-details-button' onClick={e=>{setDetails({...details,details:!details.details})}} style={{width:'25px',marginRight:'10px' }} />
                <div style={{width:'60%',verticalAlign:'middle',fontSize:'x-small',display:'inline-block',textAlign:'left'}}>
                    <div className="payment-div">
                        <label ><span style={{fontWeight:'bold',fontStyle:'normal'}}>Date : </span>{payment.date}</label>
                    </div>
                    <div className="payment-div">
                        <label ><span style={{fontWeight:'bold',fontStyle:'normal'}}>Mode : </span>{payment.mode}</label>
                   </div>
                    <div className="payment-div">
                        <label ><span style={{fontWeight:'bold',fontStyle:'normal'}}>Client : </span>{payment.end_customer.label_name}</label>
                   </div>
                    <div className="payment-div">
                        <label ><span style={{fontWeight:'bold',fontStyle:'normal'}}>Phone : </span>{payment.end_customer.phone}</label>
                   </div>
                    <div className="payment-div">
                        <label ><span style={{fontWeight:'bold',fontStyle:'normal'}}>Commande : </span>{payment.order?.order_number}</label>
                   </div>
                    <div className="payment-div">
                        <label ><span style={{fontWeight:'bold',fontStyle:'normal'}}>Reference : </span>{payment.id}</label>
                    </div>
                    <div className="payment-div">
                        <label ><span style={{fontWeight:'bold',fontStyle:'normal'}}>Montant : </span>{payment.mount} €</label>
                    </div>
                </div>
                { (payment.mode === 'Cash') && (User.is_staff || User.is_partner) && !!payment.qr_code &&
                <div style={{display:'inline-block',verticalAlign:'middle'}}>
                    <TicketView data_ticket={payment.qr_code} enable_pop_up={true} show_info={false} qr_size={50} />
                </div>
                }
        </div>
        { details.details &&
        <div style={{width:'100%',display:'inline-block',verticalAlign:'middle',marginTop:'5px'}}>
            <div className="payment-div" style={{display:'block',margin:'auto',textAlign:'center',marginTop:'5px',width:'100%'}}>
                <label ><span style={{marginRight:'10px'}}>Status :  </span>
                    <select style={{padding:'0px'}} onChange={e=>{setPayment({...payment,status:e.target.value.toLowerCase()})}} disabled className="payment-value-status" value={payment.status.toUpperCase()}>
                        <option>{'terminé'.toUpperCase()}</option>
                        <option>{'non terminé'.toUpperCase()}</option>
                    </select>
                </label>
            </div>
            {
                (UserState.is_staff) &&
                <div className='payment-div'>
                    <div style={{display:'flex',flexDirection:'row',border:'1px solid lightgray',width:'90%',margin:'auto',marginTop:'5px'}}>
                        <input onClick={e=>{if(dispHistory.display==='none'){setDispHistory({display:'block',btnText:'-'})}else{setDispHistory({display:'none',btnText:'+'})}}} type='button' value={dispHistory.btnText} style={{height:'30px',width:'30px',border:'none'}} />
                        <label style={{margin:'auto',color:'gray'}}>Historique</label>
                    </div>
                    <div style={{margin:'auto',display:dispHistory.display}}>
                        {payment.history.map(agent=>{
                            return (
                            <div className='payment-historic' style={{width:'80%',margin:'auto',borderBottom:'1px solid lightgray'}}>
                                <label style={{verticalAlign:'middle',display:'inline-block',width:'32%'}}>{dayjs(agent.date).format('YYYY-MM-DD HH:mm')}</label>
                                <div style={{verticalAlign:'middle',display:'inline-block',width:'60%',padding:'10px',color:'gray'}}>
                                    <label>{agent.agent.labelname}</label>
                                    <label style={{display:'block'}}>Contact : {agent.agent.phone}, {agent.agent.email}</label>
                                </div>
                            </div>)
                        })}
                    </div>
                </div>
            }
            { (payment.mode === 'Cash') && User.is_staff && <div className='payment-div' style={{textAlign:'right'}}><input onClick={e=>{UpdateStatus();}} disabled={_payment.status===payment.status} type='button' className='btn-payment-update' value={'Mettre à jour'} /></div>}
        </div>
        }
    </div>);
}

export default Payment
